export default "__VITE_ASSET__DDLBnfxN__"